import { render, staticRenderFns } from "./CustomersAutocomplete.vue?vue&type=template&id=d22f0634"
import script from "./CustomersAutocomplete.vue?vue&type=script&lang=js"
export * from "./CustomersAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports